import { ResourceType } from "../entities/config/resources";

export const DEFAULT_RESOURCE_PANEL_CONFIG: (ResourceType | "")[] = [
	ResourceType.LUMBER,
	ResourceType.STONE,
	ResourceType.CLAY,
	ResourceType.IRON,
	ResourceType.GOODS,
	ResourceType.STEEL,
	ResourceType.ARMY,
	ResourceType.RATIONS,
];
